import { render, staticRenderFns } from "./playAudio.vue?vue&type=template&id=58b5a7b5&scoped=true&"
import script from "./playAudio.vue?vue&type=script&lang=js&"
export * from "./playAudio.vue?vue&type=script&lang=js&"
import style0 from "./playAudio.vue?vue&type=style&index=0&id=58b5a7b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b5a7b5",
  null
  
)

export default component.exports